<template>
  <div class="background">
    <slot/>
  </div>
</template>

<script>
  export default {
    name: 'Background'
  }
</script>

<style lang="scss">
  .background {
    background-color: var(--white);
    padding: 15px;
    margin-top: 15px;
    border-radius: 3px;
  }
</style>
